<script setup lang="ts">
import type { Carrier } from '@optionway/models';

const isLg = useMediaQuery('(min-width: 1024px)');
const { locale } = useI18n();

defineProps<{
  loading?: boolean;
  departureDateTime?: string;
  carrier?: Carrier;
  compact?: boolean;
  hideDate?: boolean;
  hideTooltips?: boolean;
}>();
</script>

<template>
  <div class="flex items-center gap-2 @md:order-2 @md:min-w-36 @md:flex-col @md:gap-1">
    <!-- Date -->
    <div>
      <UiSkeleton
        v-if="loading"
        class="h-6 w-24 @md:w-40"
      />
      <div
        v-else-if="!hideDate"
        class="justify-start text-center font-semibold leading-tight text-text-primary-900"
        :class="compact ? 'text-base' : 'text-lg'"
      >
        {{ useCapitalize(useDateFormat(departureDateTime, 'ddd DD/MM', { locales: locale }).value) }}
      </div>
    </div>

    <UiCustomSeparatorDot class="@md:hidden" />

    <UiSkeleton
      v-if="loading"
      class="h-5 w-40 md:mt-1"
    />
    <div v-else>
      <UiTooltip :disabled="hideTooltips">
        <UiTooltipTrigger as-child>
          <span :aria-label="carrier?.name">
            <template v-if="carrier">
              <UiCustomAirlineLogo
                :iata-code="carrier.iataCode"
                :name="carrier.name"
                :small="false"
                class="h-5"
                aria-hidden="true"
              />
            </template>
          </span>
        </UiTooltipTrigger>
        <UiTooltipContent v-if="isLg">
          {{ carrier?.name }}
        </UiTooltipContent>
      </UiTooltip>
    </div>
  </div>
</template>
